/* RAVIN INSTANT / Phase 3.5 Step 3 — defer Fit Lab presentation until intent.
 * The original Fit Lab core, size guidance, product UI and purchasing remain eager.
 * If optional enhancements fail to load, the core modal still opens. */
(() => {
  'use strict';
  if (window.__RavinFitLabEnhancementLoader2026) return;
  const source = document.currentScript?.dataset.ravinEnhancementsSrc;
  if (!source) return;
  window.__RavinFitLabEnhancementLoader2026 = true;
  let status = 'idle';
  let pending = null;
  function load() {
    if (status === 'ready') return Promise.resolve();
    if (pending) return pending;
    status = 'loading';
    pending = new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = source;
      script.async = true;
      let settled = false;
      const complete = (ok) => {
        if (settled) return;
        settled = true;
        clearTimeout(watchdog);
        status = 'ready';
        if (!ok) console.warn('[RAVIN Fit Lab] Optional enhancements unavailable. Core sizing is active.');
        resolve();
      };
      const watchdog = setTimeout(() => complete(false), 4500);
      script.onload = () => complete(true);
      script.onerror = () => complete(false);
      document.head.appendChild(script);
    });
    return pending;
  }
  function resolveEntry(event) {
    const button = event.target?.closest?.('[data-rv-fl-open], [data-rv-fitlab-guide-trigger]');
    if (!button) return null;
    const pdp = button.closest('[data-rv-pdp-garment-file]');
    return pdp?.querySelector('[data-rv-fitlab]') ? {button, pdp} : null;
  }
  for (const name of ['pointerover', 'pointerdown', 'focusin']) {
    document.addEventListener(name, (event) => {
      if (resolveEntry(event)) void load();
    }, true);
  }
  document.addEventListener('click', (event) => {
    const match = resolveEntry(event);
    if (!match || status === 'ready') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const {button, pdp} = match;
    const selector = button.matches('[data-rv-fitlab-guide-trigger]')
      ? '[data-rv-fitlab-guide-trigger]' : '[data-rv-fl-open]';
    button.setAttribute('aria-busy', 'true');
    void load().then(() => {
      button.removeAttribute('aria-busy');
      const live = button.isConnected ? button : pdp.querySelector(selector);
      if (live?.isConnected) live.click();
    });
  }, true);
})();
